import React from 'react'
import { ReactComponent as ChevronLeft } from '../../assets/icons/chevron-left.svg'
import { useHistory } from 'react-router-dom'
import useGoTo from '../../hooks/useGoTo'

import * as S from './styles'

function BackButton ({ show = true, backPage, onClick, text = 'Voltar', paramData, outline, isFloating, noMargin = false, marginBottom, marginButton, colorButton }) {
  const history = useHistory()
  const goToPage = useGoTo()
  const goBack = () => history.goBack()

  if (!show) return <></>

  const handleBackPage = () => {
    if (backPage) goToPage(backPage, paramData)
    else goBack()
  }

  return (
    <S.Top marginBottom={marginBottom} isFloating={isFloating}>
      <S.BackButton noMargin={noMargin} colorButton={colorButton} marginButton={marginButton} outline={outline} onClick={onClick || handleBackPage}>
        <ChevronLeft />
        {text}
      </S.BackButton>
    </S.Top>
  )
}

export default BackButton
